export const version: string = "14.5.40";
